var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85476 20.5059C1.80076 12.2739 0.676758 11.4299 0.676758 8.40589C0.74515 6.35117 1.62589 4.40752 3.12571 3.00144C4.62553 1.59536 6.62191 0.841712 8.67676 0.905887C10.7316 0.841712 12.728 1.59536 14.2278 3.00144C15.7276 4.40752 16.6084 6.35117 16.6768 8.40589C16.6768 11.4299 15.5528 12.2739 9.49876 20.5059C9.40167 20.6315 9.2771 20.7331 9.13461 20.8031C8.99212 20.873 8.83549 20.9094 8.67676 20.9094C8.51802 20.9094 8.3614 20.873 8.21891 20.8031C8.07641 20.7331 7.95184 20.6315 7.85476 20.5059ZM8.67676 11.5309C9.5329 11.5576 10.3647 11.2435 10.9895 10.6577C11.6144 10.0718 11.9813 9.26197 12.0098 8.40589C11.9813 7.5498 11.6144 6.73997 10.9895 6.1541C10.3647 5.56824 9.5329 5.25419 8.67676 5.28089C7.82062 5.25419 6.98885 5.56824 6.36399 6.1541C5.73913 6.73997 5.37221 7.5498 5.34376 8.40589C5.37221 9.26197 5.73913 10.0718 6.36399 10.6577C6.98885 11.2435 7.82062 11.5576 8.67676 11.5309Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon2);
export default __webpack_public_path__ + "static/media/location_icon2.179bcdf3a5e750d31409de8900131f87.svg";
export { ForwardRef as ReactComponent };